module.exports = __webpack_public_path__ + "static/media/to.369f96bf.svg";